export class ResolutionClassificationDTO {
  code: string;
  issClassificationId?: number;
  id?: number;
  proposalName: string;
  subcategory: string;
  category?: string;
  name?: string;
}
